<template>
  <div id="app mt-0 pt-0">
    <v-app :class="themeClass">
      <div v-if="isLoading">
        <loader></loader>
      </div>
      <div v-if="!isLoading">
        <top-tool-bar
          :settings="settings"
          :bartext="selectedOptionName"
          :alertCount="alertCount"
        ></top-tool-bar>
        <left-navigation-panel :settings="settings"></left-navigation-panel>
        <v-main id="panel-container">
          <v-container class="pt-0" fluid>
            <router-view :settings="settings" @update-alert-bell="getUnreadAlertCount"></router-view>
          </v-container>
        </v-main>
      </div>
    </v-app>
  </div>
</template>

<script>
import TopToolBar from "./components/PortalComponents/TopToolBar.vue";
import LeftNavigationPanel from "./components/PortalComponents/LeftNavigationPanel.vue";
import Loader from "./components/PortalComponents/Loader.vue";
import ToolTip from "./components/PortalComponents/ToolTip.vue";
import axios from "axios";

export default {
  name: "App",
  components: {
    TopToolBar,
    LeftNavigationPanel,
    Loader,
    ToolTip,
  },
  data() {
    return {
      selectedOptionName: "",
      settings: {},
      isLoading: true,
      alertCount: 0,
    };
  },
  methods: {
    getUnreadAlertCount() {
      axios
        .get("/api/mbe/unread-alert-count")
        .then((response) => {
          this.alertCount = response.data;
        })
        .catch((error) => {
          alert(error);
        });
    },
  },
  mounted() {
    axios
      .get("/api/mbe/settings")
      .then((response) => {
        this.settings = response.data;
        this.selectedOptionName =
          this.settings.companyName + " (" + this.settings.currentAccount + ")";

          console.log("this.settings.roles", this.settings.roles);
          this.settings.roles = ["mp_admin"];
        this.getUnreadAlertCount();
        console.log("roles is now:",this.settings.roles);
        this.isLoading = false;
      })
      .catch((error) => {
        alert(error);
      });
  },
  computed: {
    themeClass() {
      return this.$vuetify.theme.dark ? 'theme-dark' : 'theme-light';
    },
  },
};
</script>

<style>
/* Higher specificity selectors */

.theme--light.v-application {
  background-color:#f8f9fa!important; /*red!important;*/ /*var(--v-background-base) !important; */
}

.theme--dark.v-application{
  background-color: #1B272D!important; /*orange!important;*/ /*var(--v-background-base) !important;*/
}

.theme--light.v-toolbar, .theme--light.v-card {
  background-color: white!important; /*var(--v-background-base) !important; */
}

.theme--dark.v-toolbar, .theme--dark.v-card {
  background-color: #22333b!important; /*var(--v-background-base) !important;*/
}

.theme--dark.v-navigation-drawer {
  background-color: #22333b !important;
}
.theme--dark .grey-text {
  color: #EAF2FBC5;
  font-weight:bold !important;
}

.theme--dark .mdi-checkbox-blank-outline{
  color:#22333b !important;
}

.theme--dark svg text {
  fill: white !important;
}
.theme--dark .apexcharts-legend-text {
  color: white !important;
  fill: white !important;
}

/* cyrillic-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/roboto/v29/KFOmCnqEu92Fr1Mu72xKOzY.woff2)
    format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
    U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/roboto/v29/KFOmCnqEu92Fr1Mu5mxKOzY.woff2)
    format("woff2");
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* greek-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/roboto/v29/KFOmCnqEu92Fr1Mu7mxKOzY.woff2)
    format("woff2");
  unicode-range: U+1F00-1FFF;
}
/* greek */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/roboto/v29/KFOmCnqEu92Fr1Mu4WxKOzY.woff2)
    format("woff2");
  unicode-range: U+0370-03FF;
}
/* vietnamese */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/roboto/v29/KFOmCnqEu92Fr1Mu7WxKOzY.woff2)
    format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1,
    U+01AF-01B0, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/roboto/v29/KFOmCnqEu92Fr1Mu7GxKOzY.woff2)
    format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/roboto/v29/KFOmCnqEu92Fr1Mu4mxK.woff2)
    format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}

#panel-container {
  padding-top: 30px !important;
}

#app {
  /*font-family: nunito, Helvetica, Arial, sans-serif;*/
  font-family: "Hanken Grotesk", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

#mobilePanelContainer {
  min-width: 1550px;
}

table th + th {
  border-left: 1px solid  #dddddd;
}
table td + td {
  border-left: 1px solid #dddddd;
}

.theme--dark table th + th{
   border-left: 1px solid #6c757d;
}

.theme--dark table td + td {
  border-left: 1px solid #6c757d;
}

html {
  overflow: auto;
}

.default {
  cursor: default !important;
}

.bring-to-front {
  z-index: 9000;
  vertical-align: top;
}

.grey-text {
  color: #808080;
}

.medium-font {
  font-size: 15px !important;
}

tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

a {
  text-decoration: none;
}

.right-align-col {
  text-align: right !important;
}

.center-me {
  text-align: center !important;
}

.apexcharts-legend-series {
  text-align: left;
}

.pt-small {
  padding-top: 3px;
}

.table-padding {
  padding-left: 25px;
  padding-right: 25px;
}

.table-header {
  white-space: nowrap;
}

.pointer {
  cursor: pointer;
}

.capital {
  text-transform: capitalize;
}

.long-header {
  width: 160px !important;
}

.disable-scroll {
  overflow: hidden;
}

.grey-text {
  color: #808080;
}

.small-font {
  font-size: 12px !important;
}

.short-chip {
  width: 40% !important;
  justify-content: center;
}

.med-chip {
  width: 100% !important;
  justify-content: center;
}

.fixed-chip {
  width: 9em !important;
  justify-content: center;
}

#landingPageContainer {
  min-width: 1550px;
}

#bar-text {
  font-size: 18px;
  color: white;
}

.v-app-bar {
  margin-top: 0px;
  padding-right: 0px;
  transform: translateY(0px);
  color: rgb(255, 255, 255);
  font-weight: bold !important;
  padding-right: 10px;
  /*font-family: nunito, Arial, Helvetica, sans-serif;*/
  font-family: "Hanken Grotesk", sans-serif;

  /*
  background-image: linear-gradient(
    to right,
    rgb(40, 54, 131),
    rgb(99, 180, 82)
  );*/
}

.white-text {
  color: white !important;
}

.is-grey,
.mdi-chevron-down,
.mdi-chevron-up {
  color: rgb(204, 204, 204) !important;
}

.disabled-button {
  pointer-events: none !important;
}

#menu-divider {
  background-color: #404040;
  width: 90%;
  margin: 0 auto;
  margin-top: 10px;
}

#nav-list {
  font-family: Roboto, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

#help-nav-option {
  bottom: 50px;
  position: absolute;
}

#elp-nav-option {
  bottom: 95px;
  position: absolute;
}

#title-text {
  font-family: Roboto, sans-serif;
  font-size: 18px;
  color: rgb(204, 204, 204);
}

#settings-nav-option {
  bottom: 10px;
  position: absolute;
}

.nav-list-item {
  color: rgb(204, 204, 204);
}

.no-pointer-events {
  pointer-events: none;
}

.v-navigation-drawer__content {
/*  background-color: black;
  color: rgb(204, 204, 204);*/
}
.v-btn:hover {
  background-color: rgb(232, 232, 232, 0.2) !important;
}

.v-btn {
  text-transform: none !important;
  font-size: 12px !important;
}

.menu-font {
  font-size: 12px;
}

.expand-left-margin {
  margin-left: -14px;
}

.v-btn--active {
  background-color: none !important;
  background: none !important;
}

.is-link {
  color: #82A62D !important;
  cursor: pointer !important;
}

@font-face {
    font-family: 'Century Gothic Test';
    font-style: normal;
    font-weight: 400;
    src: local('Century Gothic Test'), url('https://www.maintel.co.uk/wp-content/uploads/fonts/GOTHIC.woff') format('woff');
}
@font-face {
    font-family: 'Century Gothic Test';
    font-style: italic;
    font-weight: 400;
    src: local('Century Gothic Test'), url('https://www.maintel.co.uk/wp-content/uploads/fonts/GOTHICI.woff') format('woff');
}
@font-face {
    font-family: 'Century Gothic Test';
    font-style: normal;
    font-weight: 700;
    src: local('Century Gothic Test'), url('https://www.maintel.co.uk/wp-content/uploads/fonts/GOTHICB.woff') format('woff');
}
@font-face {
    font-family: 'Century Gothic Test';
    font-style: italic;
    font-weight: 700;
    src: local('Century Gothic Test'), url('https://www.maintel.co.uk/wp-content/uploads/fonts/GOTHICBI.woff') format('woff');
}

@import url("https://fonts.googleapis.com/css2?family=Nunito:wght@200;300;400;600;700&display=swap");
@import url('https://fonts.googleapis.com/css2?family=Hanken+Grotesk:ital,wght@0,100..900;1,100..900&display=swap');
</style>
